import { Collection } from 'modules/core/lib/mobx-rest'

import type Employee from 'modules/employees/store/models/Employee'
import FamilySituation from 'modules/employees/store/models/FamilySituation'

class FamilySituations extends Collection<FamilySituation> {
  get indexes() {
    return ['employee_id']
  }

  model() {
    return FamilySituation
  }

  findByEmployee(employee: Employee) {
    const familySituation = this.find({
      employee_id: employee.id,
    })

    if (familySituation) return familySituation

    return FamilySituation.getNull(+employee.id)
  }
}

export { FamilySituations }
